import React, { Component } from 'react';
import {Card, CardTitle, CardActions, CardHeader, CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import PlayArrow from 'material-ui/svg-icons/av/play-arrow';
import Pause from 'material-ui/svg-icons/av/pause';
import Stop from 'material-ui/svg-icons/av/stop';
import { connect } from 'react-redux';
import { startTimer, pauseTimer, restartTimer, stopTimer, setTimerTask} from '../components/timetracker/timer_actions';
import { convertSecondsToClockFormat } from '../utilities/time';

class Timer extends Component {
  constructor() {
    super();

    this.beginTimer = this.beginTimer.bind(this);
  }

  beginTimer() {
    if (!this.props.title) {
      return;
    }

    if (this.props.isActiveTimer) {
      this.props.restartTimer();
    }
    else {
      this.props.startTimer();
    }
  }

  render() {
    const { canStartTimer, canPauseTimer, canStopTimer, elapsedTime, isActiveTimer, userEmail, title} = this.props;
    const {  pauseTimer, stopTimer } = this.props;
    const { seconds, minutes } = convertSecondsToClockFormat(elapsedTime);
    return (
          <Card
            style={{ borderRadius: 8, marginBottom: 5, marginTop: 30, marginRight: 0, marginLeft: 0,  backgroundColor: '#ffffff', }}>
              <CardHeader
                style={{}}
                title={!title ? 'No Current Task' : title }
                subtitle={`${minutes}:${seconds}`}
                subtitleStyle={{ fontSize: 12 }}
                titleStyle={{ fontSize: 16 }}
                actAsExpander={true}
                showExpandableButton={true}
              />
            <CardText expandable={true}>
              <CardTitle title={!userEmail ? '' : userEmail} />
            <CardActions>

              <FlatButton label="Start"
              labelPosition="before"
              labelStyle={{ fontSize: '12', fontWeight: 200  }}
              icon={<PlayArrow />}
              onClick={this.beginTimer}
              disabled={!canStartTimer}
               />

             <FlatButton label="Pause"
              labelPosition="before"
              labelStyle={{ fontSize: '12', fontWeight: 200  }}
              icon={<Pause />}
              onClick={pauseTimer}
              disabled={!canPauseTimer}
              />

            <FlatButton label="Stop"
              labelPosition="before"
              labelStyle={{ fontSize: '12', fontWeight: 200  }}
              icon={<Stop />}
              onClick={stopTimer}
              disabled={!canStopTimer}
              />

            </CardActions>
            </CardText>
          </Card>
    )
  }
};

function mapStateToProps({timer}) {
  const { title, userId, userEmail, elapsedTime, canStartTimer, canPauseTimer, canStopTimer, isActiveTimer} = timer;
  return {
    userEmail,
    userId,
    title,
    elapsedTime,
    canStartTimer,
    canPauseTimer,
    canStopTimer,
    isActiveTimer,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    startTimer: () => dispatch(startTimer()),
    pauseTimer: () => dispatch(pauseTimer()),
    stopTimer: () => dispatch(stopTimer()),
    restartTimer: () => dispatch(restartTimer()),
    setTimerTask: (task) => dispatch(setTimerTask(task)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Timer);



// WEBPACK FOOTER //
// ./src/common/timer.jsx